import type { ColumnDef } from '@tanstack/react-table'
import { DataTable } from '@trellis/roots/data'
import { Typography } from '@trellis/roots/typography'

export interface ValidationError {
  row: number
  field: string
  message: string
}

const COLUMNS: ColumnDef<ValidationError>[] = [
  { accessorKey: 'row', header: 'Row', enableSorting: false },
  { accessorKey: 'field', header: 'Field', enableSorting: false },
  { accessorKey: 'message', header: 'Message', enableSorting: false },
]

export function ImportValidationErrors({ errors }: { errors: ValidationError[] }) {
  if (errors.length === 0) {
    return (
      <Typography variant="body" color="muted">
        (no errors)
      </Typography>
    )
  }
  return <DataTable columns={COLUMNS} data={errors} isLoading={false} />
}
